import React, { useContext } from "react";
import { Grid, CardHeader } from "@mui/material";
import EyeBrow from "../../commonComponents/eyeBrow/eyeBrow";
import { ThemeContext } from "styled-components";
import { MyOpenCardStyle } from "./myOpenCard.style";
import { handleKeyPress } from "utils/functions";

export interface IMyOpenCardProps {
  issues: {
    type: string;
    totalIssues: number;
  }[];
  viewListItem: (type: string) => void;
  locale: {
    incidents: string;
    requests: string;
    approvals: string;
    eyeBrowText: string;
  };
  isSmallCard?: boolean;
}

const MyOpenCard: React.FC<IMyOpenCardProps> = (props) => {
  const { issues, viewListItem, locale, isSmallCard = false } = props;
  const theme = useContext(ThemeContext);
  const ISSUES = {
    incidents: locale?.incidents,
    requests: locale?.requests,
    approvals: locale?.approvals,
  };
  return (
    <MyOpenCardStyle isSmallCard={isSmallCard}>
      <CardHeader
        title={
          <EyeBrow
            color={theme.uptimeColors.deviceCardEyebrow.activity.color}
            backgroundColor={theme.uptimeColors.deviceCardEyebrow.activity.background}
            text={locale?.eyeBrowText}
            id="chp-myopencard-status"
          />
        }
      />
      <Grid container>
        {issues.map((issue, index) => (
          <Grid item xs={issues.length === 1 ? 12 : 4} key={index} tabIndex={0}>
            <div
              className="total-issue"
              onClick={() => viewListItem(issue.type)}
              id={`lbl-myopencard-total_issue-${issue.type.toLowerCase()}`}
              onKeyDown={(e: any) =>
                handleKeyPress(e, "Enter", viewListItem(issue.type))
              }
            >
              <span>{issue.totalIssues}</span>
            </div>
            <div
              className="issue-type"
              id={`lbl-myopencard-issue-type`}
            >
              {ISSUES[issue.type]}
            </div>
          </Grid>
        ))}
      </Grid>
    </MyOpenCardStyle>
  );
};

export const defaultProps: IMyOpenCardProps = {
  issues: [
    {
      type: "approvals",
      totalIssues: 0,
    },
    {
      type: "incidents",
      totalIssues: 211,
    },
    {
      type: "requests",
      totalIssues: 31,
    },
  ],
  viewListItem: () => {},
  locale: {
    incidents: "Incidents",
    requests: "Requests",
    approvals: "Approvals",
    eyeBrowText: "ACTIVITY",
  },
};

MyOpenCard.defaultProps = defaultProps;

export default MyOpenCard;
